import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'
import { withTimeout } from '@app/utils/wait-until-timeout'

export async function waitForLiveInputsInitialization(
  timeout: number
): Promise<void> {
  let unsubscribe: () => void = () => {}

  try {
    await withTimeout<[], boolean>(
      () =>
        new Promise((resolve) => {
          const resolver = (): void => {
            resolve(true)
          }
          window.eventHub.$on('sf-live-inputs:initialized', resolver)
          unsubscribe = (): void =>
            window.eventHub.$off('sf-live-inputs:initialized', resolver)
        }),
      timeout
    )()
  } catch {
    throw new Error('Live inputs did not initialize in time')
  } finally {
    if (unsubscribe) {
      unsubscribe()
    }
  }
}

export function deleteReconciliationDetails(
  url: string,
  message: string,
  confirmationName: string
): void {
  // The unreview confirmation modal only hides the other modals,
  // that's why we need to remove the RemoveConfirmModal manually to be able to show it again.
  // We need this when the user closes the unreview confirmation modal without confirming it
  // and then tries to delete the reconciliation again.
  removePreviousSfRemoveConfirmModal()

  window.sfRemoveConfirm({
    name: confirmationName,
    message: message,
    keep: true,
    onConfirm: () => {
      deleteReconciliationWithUnreviewConfirmation(url)
    },
  })
}

// This happens when the user closes the unreview confirmation modal without confirming
// and then tries to delete the reconciliation again
function removePreviousSfRemoveConfirmModal(): void {
  const modal = document.querySelector(
    '[data-behaviour="global-confirmation-modal"].hidden'
  )
  if (modal) {
    modal.remove()
  }
}

function deleteReconciliationWithUnreviewConfirmation(url: string): void {
  window.eventHub.$emit('confirmUnreviewTemplate', {
    keepOpenAfterConfirmation: true,
    callback: () => {
      void performDelete(url)
    },
  })
}

async function performDelete(url: string): Promise<void> {
  try {
    const response = await SFetch.json<{
      channel: string
      lastId: number
      context: string
    }>(url, { method: 'DELETE' })

    if (!response) {
      return
    }

    window.Silverfin.Polling.subscribeAndReloadWhenMatching(
      response.channel,
      response.lastId,
      response.context
    )
  } catch (e) {
    SfLog.warn('Error during deleting reconciliation', {
      extra: {
        error: e,
      },
    })
  }
}
